<template>
  <div :class="{'body--cabinet': _isLoggedIn}">
    <AuthHeader v-if="!_isLoggedIn" />
    <template v-else>
      <MainHeader />
      <NavBar />
    </template>
    <router-view :key="$route.name"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import AuthHeader from '@/components/blocks/auth-header.vue';
import MainHeader from '@/components/blocks/main-header.vue';
import NavBar from '@/components/blocks/nav-bar.vue';

export default defineComponent({
  name: 'App',
  components: {
    AuthHeader,
    MainHeader,
    NavBar,
  },
  computed: {
    ...mapState('user', ['isLoggedIn']),
    _isLoggedIn() {
      return this.isLoggedIn && this.$route.name !== 'ConfirmData';
    },
  },
});
</script>

<style lang="scss">
</style>
